module.exports = __webpack_public_path__ + "img/BannerAcercaDe700x250.33d411c0.jpg";